// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container .form-input label {
  padding: 3px;
}
.search-container .form-input input {
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/search/search.styles.scss"],"names":[],"mappings":"AAEI;EACE,YAAA;AADN;AAGI;EACE,kBAAA;AADN","sourcesContent":[".search-container {\n  .form-input {\n    label {\n      padding: 3px;\n    }\n    input {\n      border-radius: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
